import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Scrolls the window back to the top whenever the route's pathname
 * changes. Rendered inside MarketingNav so it's active on every
 * marketing page (and only those — in-app `/app/*` routes don't
 * mount MarketingNav and keep their own scroll behaviour).
 *
 * If the URL has a hash (e.g. `/contact#form`), we skip the reset
 * so anchor links still work.
 */
export default function MarketingScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) return;
    window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
}
